/*
 * @Author: hollay
 * @Date:   2015-09-08 14:45:26
 * @Last Modified by: jinqiao.du
 * @Last Modified time: 2019-05-08 15:27:20
 */

'use strict';

const sniff = {}; // 结果
const TRUE = true;
const win = window;

const ua = navigator.userAgent,
    platform = navigator.platform,
    android = ua.match(/(Android);?[\s\/]+([\d.]+)?/), // 匹配 android
    ipad = ua.match(/(iPad).*OS\s([\d_]+)/), // 匹配 ipad
    ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/), // 匹配 ipod
    iphone = ua.match(/(iPhone\sOS)\s([\d_]+)/); // 匹配 iphone

sniff.ios = sniff.android = sniff.iphone = sniff.ipad = sniff.ipod = false;

// Android
if (android) {
    sniff.os = 'android';
    sniff.osVersion = android[2];
    sniff.android = TRUE;
}

// IOS
if (ipad || iphone || ipod) {
    sniff.os = 'ios';
    sniff.ios = TRUE;
}

if (iphone) {
    sniff.osVersion = iphone[2].replace(/_/g, '.');
    sniff.iphone = TRUE;
    sniff.imobile = TRUE;
    // ua判断是否是iphoneX系列机型，判断是否有刘海的情况
    // iphoneX iphone10,3
    // iphoneX iphone10,6
    // iphoneXR iphonex11,8
    // iphonexXS iphonex11,2
    // iphoneXS Max iphone11,4
    // iphoneXS Max iphone11,6
    sniff.needAddBangsClassname = sniff.isIphoneX =
        ua.match(/m\/10\.(3|6)/i) || ua.match(/m\/11\.(2|4|6|8)/i);
}

if (ipad) {
    sniff.osVersion = ipad[2].replace(/_/g, '.');
    sniff.ipad = TRUE;
}

if (ipod) {
    sniff.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : NULL;
    sniff.ipod = TRUE;
    sniff.imobile = TRUE;
}

// iOS 8+ changed UA
if (sniff.ios && sniff.osVersion && ua.indexOf('Version/') >= 0) {
    if (sniff.osVersion.split('.')[0] === '10') {
        sniff.osVersion = ua
            .toLowerCase()
            .split('version/')[1]
            .split(' ')[0];
    }
}

if (sniff.osVersion) {
    sniff.osVersionN = parseInt(sniff.osVersion.match(/\d+\.?\d*/)[0]);
}

// Pixel Ratio
sniff.pixelRatio = win.devicePixelRatio || 1;

sniff.retina = sniff.pixelRatio >= 2;

sniff.pc =
    platform.indexOf('Mac') === 0 ||
    platform.indexOf('Win') === 0 ||
    (platform.indexOf('linux') === 0 && !sniff.android);

// var match = ua.toLowerCase().match(/(qunar(a|i)phone(pro|life|deals)?)/);
let match = ua.toLowerCase().match(/(^|\s)(qunar(?!travel)[^\/]+)\/([\d\.]+)/),
    strategy = ua.toLowerCase().match(/(^|\s)(qunartravel[^\/]+)\/([\d\.]+)/);

if (match) {
    sniff.qunar = true;
    sniff.schema = match[2];
    sniff.version = match[3];
} else {
    sniff.qunar = false;
    sniff.schema = '';
}
if (strategy) {
    sniff.qunargonglve = true; // Qunar攻略客户端(detail页做特殊处理,纯touch展示)
}

module.exports = sniff;
export default sniff;
